module.exports = "<div class=calendar-small-comment> <div class=calendar-change> <span class=data-times>{{dayShow}}</span> <span class=pre-date-small> <i class=icon-calendar-date-pre></i> </span> <span class=next-date-small> <i class=icon-calendar-date-next></i> </span> </div> <div class=calendar-headers> </div> <div class=calendar-main> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.html
// module id = 4910
// module chunks = 50